/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsLayoutProps } from "@jsonforms/react";
import { ActionButton, Tooltip, TooltipTrigger } from "@adobe/react-spectrum";
import HelpOutline from "@spectrum-icons/workflow/HelpOutline";

// Lodash
import { get } from "lodash";

// Redux
import { useSelector } from "react-redux";

// Utils
import { evaluateContextRule, extractPath } from "../utils/commonUtils";

import { AllIcons } from "../utils/icons";

export const TooltipTester: RankedTester = rankWith(4, uiTypeIs("Tooltip"));

function TooltipRenderer({ uischema, visible }: RendererProps) {
  const tooltipIcon = uischema.options?.tooltipIcon;
  const content = uischema.options?.content;
  const label = uischema.options?.label;
  const className = uischema.options?.className;
  const style = uischema.options?.style;
  const labelstyle = uischema.options?.labelstyle;
  const spectrumProps = uischema.options?.spectrumProps;
  let iconJsx = null;

  if (Object.keys(AllIcons).includes(tooltipIcon)) {
    const Icon = AllIcons[tooltipIcon];
    iconJsx = <Icon {...spectrumProps} />;
  } else {
    iconJsx = (
      <HelpOutline
        size="S"
        UNSAFE_style={{ position: "absolute", top: "-2px" }}
      />
    );
  }

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    // grab the scope from the contextRule
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    // get the redux store state based on the scope provided
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    )?.visible;
  }

  return (
    <div data-testid="tooltip-test-id" hidden={!componentVisibility}>
      {label && (
        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={labelstyle}>{label}&nbsp;</span>
          <span>
            <TooltipTrigger delay={0}>
              <ActionButton
                aria-label="hint"
                UNSAFE_style={{
                  ...style,
                  marginTop: "7px",
                  border: "none",
                  height: "16px",
                }}
                UNSAFE_className={className}
              >
                {iconJsx}
              </ActionButton>
              <Tooltip>
                <div dangerouslySetInnerHTML={{ __html: content }} />
              </Tooltip>
            </TooltipTrigger>
          </span>
        </div>
      )}
    </div>
  );
}

export default withJsonFormsLayoutProps(TooltipRenderer);
